import React, { useEffect } from 'react';
import Text from '@service-victoria/component-library/components/Text';
import { StepComponent } from '@service-victoria/component-library/components/Wizard/props';
import CompletionSurvey from '@service-victoria/component-library/components/CompletionSurvey';
import UserFeedbackService from '@service-victoria/component-library/helpers/services/userFeedbackService';
import * as Interfaces from 'interfaces';
import { storage, logger, constants } from 'utils';
import * as Styled from '../styled';
import { trackEvent } from 'utils/analytics';

const {
  CompletionSurvey: Survey,
  helpers: { getAnalyticsEvents }
} = CompletionSurvey;

const events = getAnalyticsEvents('metro-voucher');

export type ComponentProps = StepComponent<Interfaces.Common.FormValues>;

const Summary: React.FC<ComponentProps> = ({ context }) => {
  const appContext = context.appStates[constants.StorageKeys.State] as Interfaces.Store.AppContext;
  const { transactionID } = appContext.currentState;

  useEffect(() => {
    storage.clear();
    logger.info(`Completed transaction for ${transactionID}`, {
      transactionID
    });
  }, [transactionID]);

  return (
    <Styled.Wrapper>
      <Styled.DoneWrapper>
        <Styled.TickWrapper />
        <Text.Heading.H1 fontWeight='bold'>Success</Text.Heading.H1>
      </Styled.DoneWrapper>
      <Styled.Spacer8 />
      <Text.Body>
        You have successfully registered for the <strong>Melbourne Travel Voucher Scheme.</strong>
      </Text.Body>
      <Text.Body>
        Application reference is <strong>{transactionID}</strong>.
      </Text.Body>
      <Text.Body>
        You will receive a confirmation email shortly. Your application will be provided to the
        Department of Jobs, Precincts &amp; Regions for administering.
      </Text.Body>
      <Text.Body>
        ​You can submit your claim for reimbursement after your travel is complete.
      </Text.Body>
      <Text.Body>
        You will be sent claim details by email, with the claim period being between{' '}
        {constants.contentDates.claimStart} and {constants.contentDates.claimDealine}.
      </Text.Body>
      <Styled.Spacer48 />
      <Text.Heading.H3 fontWeight={600}>Thank you!</Text.Heading.H3>
      <Styled.Spacer24 />
      <Text.Body>
        By travelling to metropolitan Melbourne to enjoy everything our great state has to offer,
        you are helping our state&apos;s tourism industry rebound and recover from the COVID-19
        pandemic. This will be an essential part of the state&apos;s ongoing recovery.
      </Text.Body>
      <Survey
        onThumbSelect={type => {
          trackEvent(type === 'up' ? events.thumbsUp : events.thumbsDown);
        }}
        onFeedbackGiven={async (type, message) => {
          trackEvent(events.submitFeedback);
          try {
            await new UserFeedbackService().sendFeedback({
              thumbsUp: type === 'up',
              message: message,
              transactionID: transactionID,
              transaction: 'melbourne-voucher'
            });
          } catch (e) {
            logger.error('Feedback error', e);
          }
        }}
        onSkip={() => trackEvent(events.skipFeedback)}
      />
    </Styled.Wrapper>
  );
};

export default Summary;
